import { Button, Dialog, DialogActions, 
  DialogBody, DialogContent, DialogSurface, DialogTitle, 
  DialogTrigger, Field, Input, Label, ProgressBar, 
  Spinner, Title1, makeStyles, mergeClasses, shorthands, 
  MessageBar,
  MessageBarTitle,
  MessageBarBody,
  Link,
  MessageBarActions,
  Dropdown,
  Option,
  Divider,
  Subtitle1,
  TagPicker,
  TagPickerControl,
  TagPickerGroup,
  Tag,
  Avatar,
  TagPickerInput
   } from '@fluentui/react-components';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  DismissRegular,
  Box24Regular,
  ClipboardMonth20Regular,
  DataUsage20Regular,
  Mail20Regular,
  Person20Regular,
  ReceiptMoney20Regular,
  Calendar20Regular,
  ArrowDownFilled,
  LocalLanguage20Regular
  } from "@fluentui/react-icons";

import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
import axios from 'axios';
import { useLocation, useHistory } from 'react-router-dom';
import { makeDecimalNumber } from '../../helpers/NumberFunction';
import { checkEmail } from '../../helpers/CheckEmail';

const homeStyles = {
  border: 0,
  margin: 0,
  width: '100%',
  minWidth: 'calc(100vw - 310px)',
  background: '#FAF9F8',
  position: 'relative',
};

const useStyles = makeStyles({
  root: {
      display: "flex",
      flexDirection: "column",
      width: "670px",
  },
  detail: {
      display: "flex",
      backgroundColor: "#fff",
      ...shorthands.gap("20px"),
      justifyContent: "center",
      ...shorthands.padding("10px", "20px"),
      boxShadow: "rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px",
      ...shorthands.borderRadius("10px"),
  },
  userDetail: {
      ...shorthands.border("2px", "solid", "#ccc"),
      ...shorthands.overflow("hidden"),
      display: "flex",
      height: "400px",
      width: "505px",
      ...shorthands.padding("10px", "20px"),
      ...shorthands.borderRadius("10px"),
  },
  paymentDetail: {
      ...shorthands.border("2px", "solid", "#ccc"),
      ...shorthands.overflow("hidden"),
      display: "flex",
      height: "400px",
      width: "319px",
      ...shorthands.padding("10px", "20px"),
      ...shorthands.borderRadius("10px")
  },
  flex: {
    display: "flex", 
    justifyContent: "end", 
    alignItems: "center",
    ...shorthands.gap("20px"),
  },
  flexLeft: {
    display: "flex", 
    justifyContent: "start", 
    alignItems: "center",
    ...shorthands.gap("5px"),
  },
  contentSpacing: {
    display: "flex", 
    alignItems: "center",
    ...shorthands.gap("5px"),
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    width: 'auto',
    height: 'auto',
    boxSizing: 'border-box',
    '> *': {
      textOverflow: 'ellipsis',
    },
    '> :not(:first-child)': {
      marginTop: '0px',
    },
    '> *:not(.ms-StackItem)': {
      flexShrink: 1,
    },
  },
  vertical: {
    display: 'flex',
    flexDirection: 'column',
  },
  // verticalCenter: {
  //   display: 'flex',
  //   alignItems: "center"
  // },
  fullWidth: {
    width: "100%"
  },
  spaceBetween: {
    justifyContent: "space-between"
  },
  columnGap: {
    ...shorthands.gap("0px", "10px"),
  },
  rowGap: {
    ...shorthands.gap("10px", "0px"),
  },
  horizontalCenter: {
    display: "flex",
    justifyContent: "center"
  },
  horizontalSpaceBetween: {
    display: "flex",
    justifyContent: "space-between"
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    rowGap: "10px",
  },
  verticalCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
});

const toThaiDateString = (isoDateTime) => {
  let date = '';
  date = new Date(isoDateTime);
  let year = date.getFullYear() + 543;
  let month = (date.getMonth() + 1).toString().padStart(2, '0');
  let numOfDay = date.getDate().toString().padStart(2, '0');

  let hour = date.getHours().toString().padStart(2, '0');
  let minutes = date.getMinutes().toString().padStart(2, '0');
  let second = date.getSeconds().toString().padStart(2, '0');

  return `${numOfDay}/${month}/${year} ${hour}:${minutes}:${second} น.`;
};

const API_URL = process.env.REACT_APP_API_URL;

const PackageDetail = () => {
  const history = useHistory();
  const location = useLocation();

  const { t, i18n } = useTranslation();

    const styles = useStyles();

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const [emailSentCountTotal, setEmailSentCountTotal] = useState(0)
    const [documentsTotal, setDocumentsTotal] = useState(0)

    const companyId = sessionStorage.getItem('companyId') || '';

    const [loading, setLoading] = useState(true)

    const [currentMainPackage, setCurrentMainPackage] = useState(null)
    const [currentAddOnsPackage, setCurrentAddOnsPackage] = useState([])

    const [dialog, setDialog] = useState({
      open: false,
      loading: false,
    })

    const [messageBar, setMessageBar] = useState({ show: false, status: "", type: "", title: "", message: "", actionText: "", action: null})

    const [isChange, setIsChange] = useState(false)

    const [selectPercentWht, setSelectPercentWht] = useState(0)
    const [subscriptionChecked, setSubscriptionChecked] = useState(true)

    const [manual, setManual] = useState(true)

    const [unpaidBill, setUnPaidBill] = useState([])

    const [warningDialog, setWarningDialog] = useState({
      open: false,
      header: '',
      message: '',
    })

    const [language, setLanguage] = useState('th')
    
    const [getCompanyDetailSuccess, setGetCompanyDetailSuccess] = useState(false)
    const [getPackageSuccess, setGetPackageSuccess] = useState(false)

    useEffect(() => {
      if (getCompanyDetailSuccess && getPackageSuccess) {
        setLoading(false)
      }
    }, [getCompanyDetailSuccess, getPackageSuccess])
    

    function getUnpaidStatements() {
      const documentsListEndpoint = `${API_URL}/documents/billings?status=open`
    
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const statementResponse = await axios.get(documentsListEndpoint, {
                                    headers: {
                                      Authorization: 'Bearer ' + tokenResponse.accessToken,
                                      'cid': companyId,
                                    },
                                  })

        console.log("statementResponse", statementResponse)

        const documents = statementResponse.data.data?.documents || []

        const unpaidDocuments = documents.filter(_doc => {
          if (_doc.data.billing?.disabledCancel) {
            return true
          }

          const isoTimeNow = new Date().toISOString()
          if (_doc.data.dueDate && isoTimeNow > _doc.data.dueDate) {
            return false
          }

          return true
        })

        console.log("unpaidDocuments", unpaidDocuments)

        if (unpaidDocuments.length) {
          setUnPaidBill(unpaidDocuments)

          let _total = 0

          unpaidDocuments.forEach(_document => {
            _total = _total + _document.data.paidTotal || 0
          })

          setMessageBar({ show: true, status: "WARNING", type: "warning", title: _total, message: "", actionText: "ชำระ", action: () => handleGotoPaymentDetail()})
        } 
        // else {
        //   if (currentMainPackage?.status === 'expired') {
        //     setMessageBar({ show: true, type: "error", title: 0, message: "", actionText: "ซื้อแพ็กเกจ", action: () => handleChangePackages()})
        //   }
        // }

        
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("getUnpaidStatements error", error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }

    function getPackageAndAddOns() {
      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then(async (tokenResponse) => {
        const responseCurrentPackage = await axios.get(`${API_URL}/packages/current`, {
        // const responseCurrentPackage = await axios.get(`https://ws.uat-lcpt.com/packages/current`, {
                                                        headers: {
                                                          Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                          'cid': companyId,
                                                        },
                                                      })

        const responseCurrentAddOnPackage = await axios.get(`${API_URL}/packages/add-ons/current`, {
        // const responseCurrentAddOnPackage = await axios.get(`https://ws.uat-lcpt.com/packages/add-ons/current`, {
                                                        headers: {
                                                          Authorization: 'Bearer ' + tokenResponse.accessToken,
                                                          'cid': companyId,
                                                        },
                                                      })

        console.log("responseCurrentPackage", responseCurrentPackage)
        console.log("responseCurrentAddOnPackage", responseCurrentAddOnPackage)

        if (responseCurrentPackage?.data) {
          const _from = formatDate(new Date(responseCurrentPackage.data.from))
          const _to = formatDate(new Date(responseCurrentPackage.data.to))

          const responseDocumentTotal = await axios.get(`${API_URL}/documents/summary/ALL/all?from=${_from}&to=${_to}&date=created`, {
            headers: {
              Authorization: 'Bearer ' + tokenResponse.accessToken,
              'cid': companyId,
            },
          })

          const responseSentEmailTotal = await axios.get(`${API_URL}/deliveries?from=${_from}&to=${_to}&channel=email&status=sent`, {
            headers: {
              Authorization: "Bearer " + tokenResponse.accessToken,
              "cid": companyId,
              // "Access-Control-Allow-Origin": "*",
            },
          })

          console.log("responseDocumentTotal", responseDocumentTotal)

          const { countTotal } = responseDocumentTotal.data;
          const _usedAddOnCount = responseCurrentAddOnPackage.data.packages.reduce((accumulator, _addOnsPackage) => accumulator + Number(_addOnsPackage.total - _addOnsPackage.remaining), 0);
          console.log("_usedAddOnCount", _usedAddOnCount)
          
          setDocumentsTotal((countTotal - _usedAddOnCount) >= 0 ? (countTotal - _usedAddOnCount) : responseCurrentPackage?.data.total)

          const { countTotal: countTotalEmail } = responseSentEmailTotal.data.data
          setEmailSentCountTotal(countTotalEmail)
        }
        
        setGetPackageSuccess(true)

        setCurrentMainPackage(responseCurrentPackage.data)

        const _addOnPackages = responseCurrentAddOnPackage.data.packages.filter(_addOnPackage => _addOnPackage.status === 'active')
        setCurrentAddOnsPackage(_addOnPackages)
      
      }).catch((error) => {
        //Acquire token silent failure, and send an interactive request
        console.log("getPackageAndAccountDetail error", error);
        // instance.acquireTokenRedirect(silentRequest);
      });
    }

    async function initLocationProps(_location) {
      const locationProps = _location.state
      console.log("locationProps", locationProps)
      if (locationProps) {
        const _status = locationProps.status

        if (_status === "COMPLETE") {
          setMessageBar({ show: true, status: "COMPLETE", type: "success", title: "ชำระเงินสำเร็จ", message: "สามารถดูใบเสร็จรับเงินได้", actionText: "ดู", action: null})
        } else if (_status === "CHANGE_PACKAGE") {
          setMessageBar({ show: true, status: "CHANGE_PACKAGE", type: "success", title: "เปลี่ยนแพ็กเกจสำเร็จ", message: "โดยแพ็กเกจใหม่จะเริ่มเมื่อชำระใบแจ้งค่าบริการรอบบิลถัดไป", actionText: "", action: null})
        }
      }
      
    }

    function handleCloseMessageBar() {
      setMessageBar({ show: false, type: "", title: "", message: "", actionText: "", action: null})
    }

    const formatDate = (d) => {
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      let year = d.getFullYear();
  
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
  
      return [year, month, day].join("-");
    };

    async function fetchCompanyData() {
      // console.log('userEffect retrieve company and accounts data!');
  
      instance
        .acquireTokenSilent({ ...silentRequest, account: account })
        .then((tokenResponse) => {
          console.log('tokenResponse: ', tokenResponse);
  
          axios
            .get(API_URL + '/etax/companies', {
              headers: {
                Authorization: 'Bearer ' + tokenResponse.accessToken,
              },
            })
            .then(
              (response) => {
                console.log("response /etax/companies", response.data);
  
                if (response.data.length === 0) {
                } else {
  
                  let _cid = ""
                  if (sessionStorage.getItem("companyId") && response.data.find(_company => _company.id === sessionStorage.getItem("companyId"))) {
                    // console.log(_company)

                    // setEmail(_company.email)
                    // sessionStorage.setItem("companyId", response.data[0].id);
                    _cid = sessionStorage.getItem("companyId")
                  } else {
                    const _company = response.data[0]

                    sessionStorage.setItem("companyId", _company.id);

                    // setEmail(_company.email)
  
                    _cid = _company.id
                  }
  
                  axios
                      // .get(API_URL + '/companies-details/' + response.data[0].id, {
                      .get(API_URL + '/companies-details', {
                          headers: {
                              Authorization: 'Bearer ' + tokenResponse.accessToken,
                              'cid': _cid
                          },
                      })
                      .then((companiesDetailsResponse) => {
                        if (companiesDetailsResponse.data) {
                            console.log('companiesDetailsResponse: ', companiesDetailsResponse);

                            if (companiesDetailsResponse.data.billings === undefined || companiesDetailsResponse.data.billings.manual === undefined || companiesDetailsResponse.data.billings.manual) {
                              setManual(true)
                              setLoading(false)

                              // history.push({
                              //   pathname: '/etax/documents/all',
                              //   state: {},
                              // });
                            } else {
                              setManual(false)
                            }

                            setGetCompanyDetailSuccess(true)
                            
                            setSubscriptionChecked(companiesDetailsResponse.data.billings.subscription)
                            setSelectPercentWht(companiesDetailsResponse.data.billings.wht?.percentWht || 0)
                            setLanguage(companiesDetailsResponse.data.billings.language || 'th')
                            // setEmail(companiesDetailsResponse.data.billings.company?.email || "")

                            const _emails = companiesDetailsResponse.data.billings.company?.email

                            if (_emails) {
                              setEmails(_emails.split(';'))
                            }
                        }
  
                      })
                      .catch((error) => {
                          console.log(error);
                      })
                   }
              },
              (error) => {
                console.log(error);
              }
            );
        })
        .catch((error) => {
          //Acquire token silent failure, and send an interactive request
          console.log("fetchCompanyData error", error);
          // instance.acquireTokenRedirect(silentRequest);
        });
    }

    useEffect(() => {
      fetchCompanyData()
      initLocationProps(location)

      getPackageAndAddOns()
      getUnpaidStatements()
      
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function handleOpenWarningDialog(message) {
      setWarningDialog(prev => ({...prev, open: true, message: message}))
    }

    function handleCloseWarningDialog() {
      setWarningDialog(prev => ({...prev, open: false}))
    }


    function handleChangePackages() {
      if (unpaidBill.length) return handleOpenWarningDialog(t('packageDetail.payUnpaidFirst'))
      if (currentMainPackage) {
        const timeNow = new Date()
        const timeTo = new Date(currentMainPackage.to)

        const diffTime = Math.abs(timeTo - timeNow); // difference in milliseconds
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert to days
        if (diffDays <= 5) {
          return handleOpenWarningDialog("ไม่สามารถเปลี่ยนแพ็กเกจได้จนกว่าจะถึงรอบบิลถัดไป")
        }
      }

      if (currentMainPackage.trial) {
        history.push({
          pathname: '/billings/type',
          state: {},
        });
      } else {
        history.push({
          pathname: '/packages',
          state: {},
        });
      }

    }

    function handleGotoPaymentDetail() {
      history.push({
        pathname: '/payments',
        state: {},
      });
    }

    function handleOpenDialog() {
      setDialog({
        open: true,
        loading: false,
      })
    }

    function handleCloseDialog() {
      setDialog({
        open: false,
        loading: false,
      })
    }

    async function handleSubmitBillingInfo() {
      handleCloseDialog()
      setLoading(true)

      let _emails = ''
      if (emails.length) {
        emails.forEach((_email, index) => {
          _emails = _emails + _email;

          if (emails.length - 1 !== index) {
            _emails = _emails + ';';
          }
        })
      }

      instance
      .acquireTokenSilent({ ...silentRequest, account: account })
      .then((tokenResponse) => {
        axios
        .put(`${API_URL}/companies-details/billings/` + companyId, {
          email: _emails,
          wht: selectPercentWht > -1 ? selectPercentWht : 0,
          subscription: subscriptionChecked,
          language: language
        }, {
          headers: {
            Authorization: 'Bearer ' + tokenResponse.accessToken,
            'Content-Type': 'application/json',
            'cid': companyId
          },
        })
        .then(
          (response) => {
            console.log('response handleSubmitAdditionalInfo', response);
            setIsChange(false)
            setLoading(false)
          },
          (error) => {
            console.log("error handleSubmitAdditionalInfo", error);
            setLoading(false)
          }
        );
      })
    }

    // function getPackageName(_planId) {
    //   let result = "-"
    //   if (_planId === "LECEIPT_MONTH_300") {
    //     result = t(`packageDetail.package300DocsMonth`)
    //   } else if (_planId === "LECEIPT_MONTH_500") {
    //     result = t(`packageDetail.package500DocsMonth`)
    //   } else if (_planId === "LECEIPT_MONTH_1000") {
    //     result = t(`packageDetail.package1000DocsMonth`)
    //   } else if (_planId === "LECEIPT_MONTH_3000") {
    //     result = t(`packageDetail.package3000DocsMonth`)
    //   } else if (_planId === "LECEIPT_MONTH_10000") {
    //     result = t(`packageDetail.package10000DocsMonth`)
    //   } else if (_planId === "LECEIPT_YEAR_300") {
    //     result = t(`packageDetail.package300DocsYear`)
    //   } else if (_planId === "LECEIPT_YEAR_500") {
    //     result = t(`packageDetail.package500DocsYear`)
    //   } else if (_planId === "LECEIPT_YEAR_1000") {
    //     result = t(`packageDetail.package1000DocsYear`)
    //   } else if (_planId === "LECEIPT_YEAR_3000") {
    //     result = t(`packageDetail.package3000DocsYear`)
    //   } else if (_planId === "LECEIPT_YEAR_10000") {
    //     result = t(`packageDetail.package10000DocsYear`)
    //   }

    //   return result
    // }

    function getMessageBarTitle(_messageBar) {
      if (_messageBar.status === "WARNING") {
        return `${t(`packageDetail.messageBarOverdueTitle1`)}${makeDecimalNumber(_messageBar.title)}${t(`packageDetail.messageBarOverdueTitle2`)}`

      } else if (_messageBar.status === "COMPLETE") {
        return `${t(`packageDetail.messageBarPaymentCompleteTitle`)}`
      } else if (_messageBar.status === "CHANGE_PACKAGE") {
        return `${t(`packageDetail.messageBarChangePackageTitle`)}`
      }
    }

    function getMessageBarDescription(_messageBar) {
      if (_messageBar.status === "COMPLETE") {
        return `${t(`packageDetail.messageBarPaymentCompleteMessage`)}`
      } else if (_messageBar.status === "CHANGE_PACKAGE") {
        return `${t(`packageDetail.messageBarChangePackageMessage`)}`
      }
    }

    function getMessageBarActionText(_messageBar) {
      if (_messageBar.status === "WARNING") {
        return `${t(`packageDetail.messageBarOverdueActionText`)}`

      } else if (_messageBar.status === "COMPLETE") {
        return `${t(`packageDetail.messageBarPaymentCompleteActionText`)}`
      } else if (_messageBar.status === "CHANGE_PACKAGE") {
        return ``
      }
    }

    function handleGoToAddOnPackage(e) {
      if (unpaidBill.length) return handleOpenWarningDialog(t('packageDetail.payUnpaidFirst'))
      if (!currentMainPackage) return handleOpenWarningDialog(t('packageDetail.buyMainPackageFirst'))
      if (currentMainPackage.trial) return handleOpenWarningDialog(t('packageDetail.buyMainPackageFirst'))

      history.push({
        pathname: '/packages/add-ons',
        state: {},
      });
    }

    function handleGoToHistory(e) {
      history.push({
        pathname: '/billings/histories',
        state: {},
      });
    }

    function getCurrentPackageName(currentMainPackage, language) {
      if (currentMainPackage) {
        if (language === "th") {
          return currentMainPackage.descriptionTH
        } else {
          return currentMainPackage.descriptionEN
        }
      } else {
        return "-"
      }
    }

    function getCurrentAddOnsPackageName(currentAddOnPackage, language) {
      if (currentAddOnPackage) {
        if (language === "th") {
          return currentAddOnPackage.descriptionTH
        } else {
          return currentAddOnPackage.descriptionEN
        }
      } else {
        return "-"
      }
    }

    function getButtonText(currentMainPackage) {
      if (currentMainPackage) {
        if (currentMainPackage.trial) {
          return t("packageDetail.buyPackage")
        } else {
          return t(`packageDetail.switchPackage`)
        }
      } else {
        return t("packageDetail.buyPackage")
      }
    }

    const [emails, setEmails] = useState([]);
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
      console.log("emails", emails)
    }, [emails])

    const onOptionSelect = (_, data) => {
      setEmails(data.selectedOptions);
      setIsChange(true)
    };
    const handleChange = (event) => {
      setInputValue(event.currentTarget.value);
    };
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && inputValue) {
        setInputValue("");
        if (checkEmail(inputValue)) {
          setEmails((curr) =>
            curr.includes(inputValue) ? curr : [...curr, inputValue]
          );

          setIsChange(true)
        }
      }
    };

    const handleOnBlur = () => {
      if (checkEmail(inputValue)) {
        setInputValue("");
        setEmails((curr) =>
          curr.includes(inputValue) ? curr : [...curr, inputValue]
        );

        setIsChange(true)
      } else {
        setInputValue("");
      }
    };

    return <div style={homeStyles}>
    {manual ? (
      <div style={{ display: "flex", justifyContent: "center", marginTop: 21}}>
        {loading ? (
          <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
            <Spinner labelPosition="below" label={t(`packageDetail.loading`)} />
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column"}}>
            <div style={{ marginBottom: 21}}>
              <Subtitle1>{t("packageDetail.thisPageCannotReach")}</Subtitle1>

            </div>
            <div style={{ display: "flex", justifyContent: "center"}}>
              <Button 
                appearance='primary' 
                onClick={() =>  
                  history.push({
                    pathname: '/etax/documents/all',
                    state: {},
                  })}
              >
                {t("packageDetail.homepage")}
              </Button>
              
            </div>
          </div>
        )}
      </div>
    ) : (
      <>
          <div style={{ display: "flex", justifyContent: "center"}}>
              <div className={styles.root}>
                <Title1 as='h1'>
                  <div style={{ display: "flex", flexDirection: "row"}}>
                    <div className={styles.verticalCenter} style={{ paddingRight: 5}}>
                      <Box24Regular />
                    </div>
                    <div className={styles.verticalCenter}>
                      <div>{t(`packageDetail.package`)}</div>
                    </div>
                  </div>
                </Title1>
                {messageBar.show ? (
                  <>
                    <MessageBar style={{ height: 50}} intent={messageBar.type}>
                      <MessageBarBody>
                        <MessageBarTitle style={{ fontSize: 20}}>{getMessageBarTitle(messageBar)}</MessageBarTitle>
                        {getMessageBarDescription(messageBar)}
                      </MessageBarBody>
                      <MessageBarActions
                        containerAction={
                          messageBar.type === "success" ? (
                            <Button
                              aria-label="dismiss"
                              appearance="transparent"
                              icon={<DismissRegular />}
                              onClick={handleCloseMessageBar}
                            />
                          ) : null
                          
                        }
                      >
                        {messageBar.actionText ? (
                          <Button size='large' appearance='primary' onClick={() => messageBar.action()}>{getMessageBarActionText(messageBar)}</Button>
                        ) : null}
                      </MessageBarActions>
                    </MessageBar>
                    <br />
                  </>

                ) : null}
                    {loading ? (
                      <div className={mergeClasses(styles.detail, styles.vertical)}>
                        <div style={{ display: "flex", alignContent: "center", height: "100%", width: "100%", justifyContent: "center"}}>
                          <Spinner labelPosition="below" label={t(`packageDetail.loading`)} />
                        </div>
                      </div>
                    ) : (
                      <>
                      <div className={mergeClasses(styles.detail, styles.vertical)}>
                        <div>
                          <h2>{t("packageDetail.mainPackage")}</h2>
                          <Divider />
                        </div>
                        <div className={mergeClasses(styles.fullWidth, styles.horizontalSpaceBetween)}>
                          <h2>{getCurrentPackageName(currentMainPackage, i18n.language)}</h2>
                          <div className={styles.verticalCenter} style={{ width: 195}}>
                            <Button size='medium' onClick={handleChangePackages} >
                              {getButtonText(currentMainPackage)}
                            </Button>
                          </div>
                        </div>
                        <Field label={
                          <div className={styles.horizontalSpaceBetween}>
                            <div className={styles.verticalCenter}>
                              <ClipboardMonth20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.currentBillPeriod`)}
                            </div>
                            <div className={styles.verticalCenter}>
                              <div>
                                {currentMainPackage ? `${toThaiDateString(currentMainPackage.from)} - ${toThaiDateString(currentMainPackage.to)}` : "-"}

                              </div>
                            </div>
                          </div>
                        } ></Field>
                        {currentMainPackage ? (
                          <Field label={
                            <div className={styles.horizontalSpaceBetween}>
                              <div className={styles.verticalCenter}>
                                <DataUsage20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.usageAmount`)}
                              </div>
                              <div className={styles.verticalCenter}>
                                <div>
                                  {documentsTotal} / {currentMainPackage.total} {t(`packageDetail.document`)}

                                </div>
                              </div>
                            </div>
                          } validationMessage={
                            <div style={{ display: "flex", justifyContent: "flex-end"}}>
                              {t(`packageDetail.usageAmountLeft`)}: {currentMainPackage.total - documentsTotal} {t(`packageDetail.document`)}
                            </div>
                            } validationState="none">
                            <ProgressBar
                              className={styles.container}
                              thickness="large"
                              value={documentsTotal / currentMainPackage.total}
                            />
                          </Field>
                        ) : null}
                        {/* <Field label={
                          <div className={styles.horizontalSpaceBetween}>
                            <div className={styles.verticalCenter}>
                              <DataUsage20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.amountOverused`)}
                            </div>
                            <div className={styles.verticalCenter}>
                              <div>
                                {usedCredits > maxCredits ? usedCredits - maxCredits : 0}
                              </div>
                            </div>
                          </div>
                        } >
                          
                        </Field> */}
                        {currentMainPackage?.monthsLimit !== 1 ? (
                          <Field label={
                            <div className={styles.horizontalSpaceBetween}>
                              <div className={styles.verticalCenter}>
                                <Calendar20Regular style={{ paddingRight: 5}} /> {t("packageDetail.monthRemaining")}
                              </div>
                              <div className={styles.verticalCenter}>
                                <div>
                                  {currentMainPackage?.monthRemaining}
  
                                </div>
                              </div>
                            </div>
                          } ></Field>
                        ) : null}
                        <Field label={
                          <div className={styles.horizontalSpaceBetween}>
                            <div className={styles.verticalCenter}>
                              <Mail20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.emailSentCount`)}
                            </div>
                            <div className={styles.verticalCenter}>
                              <div>
                                {emailSentCountTotal} {t(`packageDetail.emailUnit`)}

                              </div>
                            </div>
                          </div>
                        } ></Field>
                        {/* <Field label={
                          <div className={styles.horizontalSpaceBetween}>
                            <div className={styles.verticalCenter}>
                              <Send20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.smsSentCount`)}
                            </div>
                            <div className={styles.verticalCenter}>
                              <div>
                                {smsSentCountTotal}

                              </div>
                            </div>
                          </div>
                        } >
                        </Field> */}
                      </div>
                      <br />
                      <div className={mergeClasses(styles.detail, styles.vertical)}>
                        <div>
                          <h2>{t("packageDetail.addOnPackage")}</h2>
                          <Divider />
                        </div>
                        {currentAddOnsPackage.map((_addOnsPackage, index) => (
                          <Fragment key={_addOnsPackage.id}>
                            <div className={mergeClasses(styles.fullWidth, styles.horizontalSpaceBetween)}>
                              <h2>{getCurrentAddOnsPackageName(_addOnsPackage, i18n.language)}</h2>
                              
                            </div>
                            <Field label={
                              <div className={styles.horizontalSpaceBetween}>
                                <div className={styles.verticalCenter}>
                                  <ClipboardMonth20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.currentBillPeriod`)}
                                </div>
                                <div className={styles.verticalCenter}>
                                  <div>
                                    {_addOnsPackage ? `${toThaiDateString(_addOnsPackage.from)} - ${toThaiDateString(_addOnsPackage.to)}` : "-"}

                                  </div>
                                </div>
                              </div>
                            } ></Field>
                            <Field label={
                              <div className={styles.horizontalSpaceBetween}>
                                <div className={styles.verticalCenter}>
                                  <DataUsage20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.usageAmount`)}
                                </div>
                                <div className={styles.verticalCenter}>
                                  <div>
                                    {_addOnsPackage.total - _addOnsPackage.remaining} / {_addOnsPackage.total} {t(`packageDetail.document`)}

                                  </div>
                                </div>
                              </div>
                            } validationMessage={
                              <div style={{ display: "flex", justifyContent: "flex-end"}}>
                                {t(`packageDetail.usageAmountLeft`)}: {_addOnsPackage.total - (_addOnsPackage.total - _addOnsPackage.remaining)} {t(`packageDetail.document`)}
                              </div>
                              } validationState="none">
                              <ProgressBar
                                className={styles.container}
                                thickness="large"
                                value={(_addOnsPackage.total - _addOnsPackage.remaining) / _addOnsPackage.total}
                              />
                            </Field>
                            {index !== currentAddOnsPackage.length - 1 ? (
                              <Divider />
                            ) : null}
                          </Fragment>
                        ))}
                        <div className={styles.horizontalCenter} style={{ marginBottom: 10}}>
                          <Button size='medium' onClick={handleGoToAddOnPackage} >
                            {t("packageDetail.buyAddOnPackage")}
                          </Button>
                        </div>
                      </div>
                      <br />
                      <div className={mergeClasses(styles.detail, styles.vertical)}>
                        {/* <Field label={
                          <div className={styles.horizontalSpaceBetween} style={{ marginTop: 15}}>
                            <div className={styles.verticalCenter}>
                              <Person20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.emailForReceiveInvoice`)}
                            </div>
                            <div className={styles.verticalCenter}>
                              <div>
                                <Input style={{ width: 250 }} type="email" value={email} onChange={(e) => {
                                  setIsChange(true)
                                  setEmail(e.target.value)
                                }} />
                              </div>
                            </div>
                          </div>
                        } >
                        </Field> */}
                        <Field label={
                          <div className={styles.horizontalSpaceBetween} style={{ marginTop: 15}}>
                            <div className={styles.horizontalCenter} style={{ marginTop: 5}}>
                              <div>
                              <Person20Regular style={{ paddingRight: 5}} />
                              </div>
                              <div>
                               {t(`packageDetail.emailForReceiveInvoice`)}
                                
                              </div>
                            </div>
                            <div>
                              <div>
                                <Field style={{ maxWidth: 250 }}>
                                  <TagPicker
                                    noPopover
                                    onOptionSelect={onOptionSelect}
                                    selectedOptions={emails}
                                  >
                                    <TagPickerControl expandIcon={<ArrowDownFilled style={{ display: "none"}} />}>
                                      <TagPickerGroup aria-label="Selected Employees">
                                        {emails.length ? emails.map((option, index) => (
                                          <Tag
                                            key={index}
                                            shape="rounded"
                                            media={<Avatar aria-hidden name={option} color="colorful" />}
                                            value={option}
                                          >
                                            {option}
                                          </Tag>
                                        )) : []}
                                      </TagPickerGroup>
                                      <TagPickerInput
                                        value={inputValue}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                        onBlur={handleOnBlur}
                                        aria-label="Add Employees"
                                      />
                                    </TagPickerControl>
                                    <Input style={{ display: "none"}} />
                                  </TagPicker>
                                </Field>
                              </div>
                            </div>
                          </div>
                        } >
                        </Field>
                        
                        <Field label={
                            <div className={styles.horizontalSpaceBetween}>
                              <div className={styles.verticalCenter}>
                                <ReceiptMoney20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.taxWithheldRate`)}
                              </div>
                              <div className={styles.verticalCenter}>
                                <div>
                                <Dropdown
                                  aria-labelledby="percentWhtLabel"
                                  // placeholder={t(`packageDetail.pleaseSelect`)}
                                  value={selectPercentWht > 0 ? selectPercentWht : t(`packageDetail.notTaxWithheld`)}
                                >
                                  <Option key={0} value={0} onClick={() => {
                                      setIsChange(true)
                                      setSelectPercentWht(0)
                                    }
                                  }>
                                    {t(`packageDetail.notTaxWithheld`)}
                                  </Option>
                                  <Option key={1} value={1} onClick={() => {
                                      setIsChange(true)
                                      setSelectPercentWht(1)
                                    }
                                  }>
                                    {1}
                                  </Option>
                                  <Option key={3} value={3} onClick={() => {
                                      setIsChange(true)
                                      setSelectPercentWht(3)
                                    }
                                  }>
                                    {3}
                                  </Option>
                                </Dropdown>

                                </div>
                              </div>
                            </div>
                          } >
                          </Field>
                        <Field label={
                          <div className={styles.horizontalSpaceBetween}>
                              <div className={styles.verticalCenter}>
                                <LocalLanguage20Regular style={{ paddingRight: 5}} /> {t(`packageDetail.language`)}
                              </div>
                              <div className={styles.verticalCenter}>
                                <div>
                                <Dropdown
                                  aria-labelledby="percentWhtLabel"
                                  // placeholder={t(`packageDetail.pleaseSelect`)}
                                  value={language === "th" ? t(`packageDetail.thaiPaper`) : t(`packageDetail.englishPaper`)}
                                >
                                  <Option key="th" value="th" onClick={() => {
                                      setIsChange(true)
                                      setLanguage("th")
                                    }
                                  }>
                                    {t(`packageDetail.thaiPaper`)}
                                  </Option>
                                  <Option key="en" value="en" onClick={() => {
                                      setIsChange(true)
                                      setLanguage("en")
                                    }
                                  }>
                                    {t(`packageDetail.englishPaper`)}
                                  </Option>
                                </Dropdown>

                                </div>
                              </div>
                            </div>
                          }>
                        </Field>
                        <div className={styles.horizontalCenter} style={{ marginBottom: 10}}>
                          <Button 
                            disabled={!isChange} 
                            size='large' 
                            appearance='primary'
                            onClick={handleOpenDialog}
                          >
                            {t(`packageDetail.save`)}
                          </Button>

                        </div>

                      </div>
                      
                      </>
                    )}
              </div>
              
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "center"}}>
            <div className={styles.root} >
              <div style={{ justifyContent: "flex-end", display: "flex", paddingRight: 20}}>
                <div style={{ display: "flex", flexDirection: "row", gap: 20}}>
                  {/* <Link onClick={handleGoToAddOnPackage}>
                    ซื้อแพ็กเกจเสริม
                  </Link> */}
                  <Link onClick={handleGoToHistory}>
                    {t(`packageDetail.paymentHistory`)}
                  </Link>
                </div>

              </div>
            </div>
          </div>
          <Dialog open={dialog.open} onOpenChange={handleCloseDialog}>
            <DialogSurface style={{ width: 300}}>
              <DialogBody>
                <DialogTitle>{t(`packageDetail.confirmSaveHeader`)}</DialogTitle>
                <DialogContent className={styles.dialogContent} style={{ marginBottom: 10}}>
                  <Label id="percentWhtLabel">
                    {t(`packageDetail.confirmSaveDescription`)}
                  </Label>
                  
                </DialogContent>
                <DialogActions>
                  <Button appearance="primary" onClick={handleSubmitBillingInfo}>
                    {t(`packageDetail.save`)}
                  </Button>
                  <DialogTrigger disableButtonEnhancement>
                    <Button appearance="secondary" onClick={handleCloseDialog}>{t(`packageDetail.close`)}</Button>
                  </DialogTrigger>
                </DialogActions>
              </DialogBody>
            </DialogSurface>
          </Dialog>
          <Dialog open={warningDialog.open} onOpenChange={handleCloseWarningDialog}>
            <DialogSurface style={{ width: 350 }}>
              <DialogBody>
                <DialogTitle style={{ textAlign: "center" }}>{warningDialog.message}</DialogTitle>
                <DialogContent className={styles.dialogContent} style={{ textAlign: "center" }}>
                  <div style={{ display: "flex", justifyContent: "center", width: "100%", gap: 10}}>
                    <Button type="submit" appearance="primary" onClick={handleCloseWarningDialog}>
                      {t(`packageDetail.back`)}
                    </Button>
                  </div>
                </DialogContent>
              </DialogBody>
            </DialogSurface>
          </Dialog>
      </>
    )}
    </div>
};

export default PackageDetail;
